/* Mama Jewels: "Reviews" row + side panel (snippets/mj-reviews-drawer.liquid).
   Closing is handled by the material panel script in the product template
   (every [data-mj-close] closes every body > .mj-drawer). */
(function () {
  if (window.mjReviewsDrawerReady) return;
  window.mjReviewsDrawerReady = true;

  var API = 'https://cdn.judge.me/reviews/reviews_for_widget';
  var PER_PAGE = 10;
  var state = { html: null, page: 0, pages: 1 };

  var starPath = 'M12 2.8l2.8 5.9 6.4.8-4.7 4.5 1.2 6.4L12 17.3l-5.7 3.1 1.2-6.4L2.8 9.5l6.4-.8z';
  function stars(rating) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      html += '<svg class="mj-pr__star' + (rating >= i ? '' : ' mj-pr__star--off') + '" viewBox="0 0 24 24" aria-hidden="true"><path d="' + starPath + '"/></svg>';
    }
    return html;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function displayName(name) {
    var parts = String(name || '').trim().split(/\s+/);
    var first = parts[0] ? parts[0].charAt(0).toUpperCase() + parts[0].slice(1) : '';
    return parts.length > 1 ? first + ' ' + parts[parts.length - 1].charAt(0).toUpperCase() + '.' : first;
  }
  /* body_html comes from customers: parse it inertly and keep only the text. */
  function plainText(html) {
    var doc = new DOMParser().parseFromString('<div>' + String(html || '').replace(/<br\s*\/?>/gi, '\n') + '</div>', 'text/html');
    return doc.body.textContent.replace(/\n\s*\n+/g, '\n').trim();
  }
  function formatDate(iso) {
    var d = new Date(iso);
    return isNaN(d) ? '' : d.toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' });
  }
  function base(url) { return String(url || '').split('?')[0]; }

  function renderReview(r) {
    var pics = (r.pictures_urls || []).slice(0, 4).map(function (p) {
      return '<a href="' + esc(p.huge) + '" target="_blank" rel="noopener"><img src="' + esc(base(p.original)) + '?quality=80&width=240" alt="" loading="lazy" width="240" height="240"></a>';
    }).join('');
    return '<li class="mj-rd__item">' +
      '<div class="mj-rd__item-top"><span class="mj-rd-stars" role="img" aria-label="' + r.rating + ' von 5 Sternen">' + stars(r.rating) + '</span>' +
      '<span class="mj-rd__date">' + esc(formatDate(r.created_at)) + '</span></div>' +
      '<p class="mj-rd__who">' + esc(displayName(r.reviewer_name)) + (r.verified_buyer ? '<span> · Verifizierter Kauf</span>' : '') + '</p>' +
      (r.title ? '<h3 class="mj-rd__title">' + esc(r.title) + '</h3>' : '') +
      '<p class="mj-rd__body">' + esc(plainText(r.body_html)) + '</p>' +
      (pics ? '<div class="mj-rd__pics">' + pics + '</div>' : '') +
      '</li>';
  }

  function load(panel, page) {
    var list = panel.querySelector('[data-mj-rd-list]');
    var more = panel.querySelector('[data-mj-rd-more]');
    var url = API + '?product_id=' + encodeURIComponent(panel.dataset.productId) +
      '&page=' + page + '&per_page=' + PER_PAGE + '&sort_by=pictures_first' +
      '&shop_domain=' + encodeURIComponent(panel.dataset.shop) + '&platform=shopify';
    if (more) { more.disabled = true; }
    return fetch(url)
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (data) {
        var html = (data.reviews || []).map(renderReview).join('');
        if (page === 1) list.innerHTML = html; else list.insertAdjacentHTML('beforeend', html);
        state.page = page;
        state.pages = (data.pagination && data.pagination.total_pages) || 1;
        state.html = list.innerHTML;
        if (more) { more.hidden = state.page >= state.pages; more.disabled = false; }
      })
      .catch(function () {
        /* keep the reviews rendered by Liquid; just hide "Show more" */
        if (more) more.hidden = true;
      });
  }

  function open() {
    var tpl = document.querySelector('[data-mj-rd-template]');
    if (!tpl) return;
    /* Like the material panel: a fresh copy on <body>, so position: fixed covers the viewport. */
    document.querySelectorAll('body > .mj-drawer').forEach(function (x) { x.remove(); });
    var panel = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(panel);
    document.body.classList.add('mj-drawer-open');
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    var list = panel.querySelector('[data-mj-rd-list]');
    var more = panel.querySelector('[data-mj-rd-more]');
    if (state.html) {
      list.innerHTML = state.html;
      if (more) more.hidden = state.page >= state.pages;
    } else {
      load(panel, 1);
    }
    if (more) more.addEventListener('click', function () { load(panel, state.page + 1); });
    var close = panel.querySelector('.mj-drawer__close');
    if (close) close.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mj-rd-open]')) { e.preventDefault(); open(); return; }
    /* "Write a review": close the panel and open Judge.me's own review form (set up in mj-pdp-reviews.js). */
    if (e.target.closest('[data-mj-rd-write]')) {
      e.preventDefault();
      document.querySelectorAll('body > .mj-drawer').forEach(function (d) { d.classList.remove('is-open'); });
      document.body.classList.remove('mj-drawer-open');
      if (window.mjOpenReviewForm) window.mjOpenReviewForm();
    }
  });
})();
